// Amaross Caster — minimal theme JS
// Reserved for future interactive behavior (mobile nav, cart drawer, etc.)
document.addEventListener('DOMContentLoaded', function () {
  // no-op placeholder: keep file small, add behavior as needed
});
